import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { businessInfo } from '../mockData';
import { siteConfig } from '../content/siteContent';
import { serviceAreas } from '../content/serviceAreas';
import usePageMeta from '../hooks/usePageMeta';

const ServiceAreas = () => {
  usePageMeta();
  return (
    <div className="min-h-screen">
      <section className="relative bg-gray-950 py-16 sm:py-20 text-white overflow-hidden">
        <div className="absolute inset-0" aria-hidden="true">
          <img src="/images/projects/north-shore-hospital.webp" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-950 from-25% via-gray-950/75 via-55% to-gray-950/5"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-bold mb-5">Locksmith service areas — North Shore</h1>
            <p className="text-xl text-gray-300 mb-8">
              We're a mobile locksmith covering Auckland's North Shore. Find your suburb below —
              or just give us a call and we'll come to you.
            </p>
            <a href={`tel:${businessInfo.phoneTel}`}>
              <Button size="lg" className="bg-red-600 text-white hover:bg-red-700 font-bold text-lg px-8">
                <Phone className="mr-2" size={20} />
                Call {businessInfo.phone}
              </Button>
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {serviceAreas.map((area) => (
              <Link key={area.slug} to={`/service-areas/${area.slug}`} className="block group">
                <Card className="border-gray-200 h-full group-hover:border-red-300 group-hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-3 mb-2">
                      <MapPin className="text-red-600 flex-shrink-0" size={20} />
                      <h2 className="text-xl font-bold text-gray-900">Locksmith {area.name}</h2>
                    </div>
                    <p className="text-sm text-gray-600 line-clamp-3">{area.blurb}</p>
                    <span className="text-red-600 font-semibold text-sm flex items-center gap-1 mt-4">
                      {area.name} locksmith <ArrowRight size={14} />
                    </span>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
          <p className="text-center text-gray-600 mt-10 max-w-2xl mx-auto">
            Elsewhere on the North Shore or wider Auckland? We still cover a lot of ground —
            {' '}<a href={`tel:${businessInfo.phoneTel}`} className="text-red-600 font-semibold">call {businessInfo.phone}</a>
            {' '}and we'll let you know. {siteConfig.hoursLine}.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreas;
